<template>
  <div class="catalog-cart" @click.stop>
    <div v-if="quantity" class="catalog-cart-counter" :aria-busy="busy ? 'true' : 'false'">
      <button type="button" :disabled="disabled" :aria-label="`Зменшити кількість: ${product.name}`" @click="change(-1)">−</button>
      <span role="status" :aria-label="`У кошику: ${quantity}`">{{ quantity }}</span>
      <button type="button" :disabled="disabled || quantity >= stock" :aria-label="`Збільшити кількість: ${product.name}`" @click="change(1)">+</button>
    </div>
    <button v-else type="button" class="catalog-cart-add" :disabled="disabled || stock < 1" :aria-label="`У кошик: ${product.name}`" @click="change(1)">
      {{ busy ? 'Додаємо…' : stock === 0 ? 'Немає в наявності' : '+ У кошик' }}
    </button>
    <p v-if="error" class="catalog-cart-error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "ProductCartControl",
  props: {
    product: { type: Object, required: true },
    active: { type: Boolean, default: true },
  },
  data: () => ({ busy: false, error: "" }),
  computed: {
    item() {
      return (this.$store.getters.getCustomerCart?.items || []).find(
        item => String(item.product_id) === String(this.product.id) && !item.no_product
      );
    },
    quantity() { return Number(this.item?.qty_item) || 0; },
    stock() { return this.product.available === false ? 0 : Number(this.item?.qty_product ?? this.product.qty) || 0; },
    disabled() { return !this.active || !this.$store.getters.cartReady || this.$store.getters.cartUpdating; },
  },
  methods: {
    async change(direction) {
      if (this.disabled) return;
      this.error = "";
      this.busy = true;
      try {
        await this.$store.dispatch("changeCatalogCartQuantity", { product: this.product, direction });
      } catch (error) {
        this.error = "Не вдалося змінити кошик. Спробуйте ще раз.";
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.catalog-cart { margin: 8px 6px 6px; }
.catalog-cart-add, .catalog-cart-counter { width: 100%; min-height: 44px; border-radius: 6px; }
.catalog-cart-add { border: 0; background: #16abb8; color: #fff; font: 600 13px/18px Inter, sans-serif; padding: 8px 4px; cursor: pointer; }
.catalog-cart-counter { display: flex; align-items: center; justify-content: space-between; border: 1px solid #16abb8; background: #fff; }
.catalog-cart-counter button { flex: 0 0 44px; min-height: 44px; border: 0; background: transparent; color: #333; font-size: 20px; cursor: pointer; }
.catalog-cart-counter span { font: 600 14px/20px Inter, sans-serif; color: #333; }
button:disabled { opacity: 0.5; cursor: default; }
button:focus-visible { outline: 2px solid #075a63; outline-offset: 2px; }
.catalog-cart-error { margin-top: 6px; color: #a42020; font: 12px/16px Inter, sans-serif; }
</style>
